// src/pages/Clubs/CreateClubModal.jsx
import React, { useState } from "react";
import { FaSave, FaTimes } from "react-icons/fa";
import Button from "./../../components/Button/Button";
import { addClubGirondin } from "./../../services/clubsgirondinsServices";
import { useUser } from "./../../contexts/UserContext";
import { getRoleFromRoleId } from "./../../utils/roleHelper";

const CreateClubModal = ({ isOpen, onClose, refreshList }) => {
  const { user } = useUser();
  const userRole = getRoleFromRoleId(user?.role_id);

  const [formData, setFormData] = useState({
    nom_club: "",
    commune: "",
    secteur: "",
    secteur_geo: "",
    numero_club: "",
    tel: "",
    mail: "",
    president: "",
    enseignant: "",
    adresse: "",
    site_internet: "",
    reseaux_sociaux: "",
    lien_logo: "",
    coordonnees_gps: "",
    lien_maps: "",
    disciplines: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await addClubGirondin(formData);
      refreshList();
      onClose();
      setFormData({
        nom_club: "",
        commune: "",
        secteur: "",
        secteur_geo: "",
        numero_club: "",
        tel: "",
        mail: "",
        president: "",
        enseignant: "",
        adresse: "",
        site_internet: "",
        reseaux_sociaux: "",
        lien_logo: "",
        coordonnees_gps: "",
        lien_maps: "",
        disciplines: "",
      });
    } catch (error) {
      console.error("Erreur lors de la création du club", error);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
      <div className="modal-box-clubsgirondins max-h-[90vh] w-full max-w-4xl overflow-y-auto rounded-2xl bg-white dark:bg-slate-900 shadow-2xl border border-slate-200/70 dark:border-slate-700/70">
        {/* HEADER */}
        <div className="flex items-center justify-between border-b border-slate-200/70 dark:border-slate-700/70 px-5 py-4">
          <div>
            <h3 className="text-lg sm:text-xl font-bold uppercase tracking-[0.15em] text-slate-800 dark:text-slate-50">
              Créer un club
            </h3>
            <p className="mt-1 text-xs text-slate-500 dark:text-slate-300">
              Renseignez les informations principales du club girondin.
            </p>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="inline-flex h-8 w-8 items-center justify-center rounded-full bg-slate-100 text-slate-500 hover:bg-slate-200 dark:bg-slate-800 dark:text-slate-200 dark:hover:bg-slate-700 transition-colors"
            aria-label="Fermer la fenêtre"
          >
            <FaTimes />
          </button>
        </div>

        {/* FORM */}
        <form onSubmit={handleSubmit} className="px-5 pb-5 pt-4 space-y-6">
          {/* SECTION : Infos générales */}
          <section className="rounded-xl bg-slate-50/80 dark:bg-slate-800/80 p-4 space-y-3">
            <h4 className="text-xs font-semibold uppercase tracking-[0.18em] text-slate-500 dark:text-slate-300 mb-1">
              Informations générales
            </h4>
            <div className="grid md:grid-cols-2 gap-3">
              <div>
                <label className="label-text text-xs font-semibold text-slate-600 dark:text-slate-200">
                  Nom du club *
                </label>
                <input
                  type="text"
                  name="nom_club"
                  value={formData.nom_club}
                  onChange={handleChange}
                  className="input input-bordered w-full mt-1 dark:bg-slate-900 dark:border-slate-700 dark:text-white"
                  required
                />
              </div>

              <div>
                <label className="label-text text-xs font-semibold text-slate-600 dark:text-slate-200">
                  Commune *
                </label>
                <input
                  type="text"
                  name="commune"
                  value={formData.commune}
                  onChange={handleChange}
                  className="input input-bordered w-full mt-1 dark:bg-slate-900 dark:border-slate-700 dark:text-white"
                  required
                />
              </div>

              <div>
                <label className="label-text text-xs font-semibold text-slate-600 dark:text-slate-200">
                  Numéro du club
                </label>
                <input
                  type="text"
                  name="numero_club"
                  value={formData.numero_club}
                  onChange={handleChange}
                  className="input input-bordered w-full mt-1 dark:bg-slate-900 dark:border-slate-700 dark:text-white"
                />
              </div>

              <div>
                <label className="label-text text-xs font-semibold text-slate-600 dark:text-slate-200">
                  Disciplines (séparées par /)
                </label>
                <input
                  type="text"
                  name="disciplines"
                  value={formData.disciplines}
                  onChange={handleChange}
                  placeholder="Ex : Judo / Jujitsu / Taïso"
                  className="input input-bordered w-full mt-1 dark:bg-slate-900 dark:border-slate-700 dark:text-white"
                />
              </div>
            </div>
          </section>

          {/* SECTION : Contact */}
          <section className="rounded-xl bg-slate-50/80 dark:bg-slate-800/80 p-4 space-y-3">
            <h4 className="text-xs font-semibold uppercase tracking-[0.18em] text-slate-500 dark:text-slate-300 mb-1">
              Coordonnées & contact
            </h4>
            <div className="grid md:grid-cols-2 gap-3">
              <div>
                <label className="label-text text-xs font-semibold text-slate-600 dark:text-slate-200">
                  Téléphone
                </label>
                <input
                  type="text"
                  name="tel"
                  value={formData.tel}
                  onChange={handleChange}
                  placeholder="Ex : 06 00 00 00 00"
                  className="input input-bordered w-full mt-1 dark:bg-slate-900 dark:border-slate-700 dark:text-white"
                />
              </div>

              <div>
                <label className="label-text text-xs font-semibold text-slate-600 dark:text-slate-200">
                  Email
                </label>
                <input
                  type="email"
                  name="mail"
                  value={formData.mail}
                  onChange={handleChange}
                  placeholder="Ex : club@exemple.fr"
                  className="input input-bordered w-full mt-1 dark:bg-slate-900 dark:border-slate-700 dark:text-white"
                />
              </div>

              <div>
                <label className="label-text text-xs font-semibold text-slate-600 dark:text-slate-200">
                  Président
                </label>
                <input
                  type="text"
                  name="president"
                  value={formData.president}
                  onChange={handleChange}
                  className="input input-bordered w-full mt-1 dark:bg-slate-900 dark:border-slate-700 dark:text-white"
                />
              </div>

              <div>
                <label className="label-text text-xs font-semibold text-slate-600 dark:text-slate-200">
                  Enseignant(s)
                </label>
                <input
                  type="text"
                  name="enseignant"
                  value={formData.enseignant}
                  onChange={handleChange}
                  className="input input-bordered w-full mt-1 dark:bg-slate-900 dark:border-slate-700 dark:text-white"
                />
              </div>
            </div>
          </section>

          {/* SECTION : Localisation */}
          <section className="rounded-xl bg-slate-50/80 dark:bg-slate-800/80 p-4 space-y-3">
            <h4 className="text-xs font-semibold uppercase tracking-[0.18em] text-slate-500 dark:text-slate-300 mb-1">
              Localisation
            </h4>
            <div className="grid md:grid-cols-2 gap-3">
              <div className="md:col-span-2">
                <label className="label-text text-xs font-semibold text-slate-600 dark:text-slate-200">
                  Adresse
                </label>
                <input
                  type="text"
                  name="adresse"
                  value={formData.adresse}
                  onChange={handleChange}
                  className="input input-bordered w-full mt-1 dark:bg-slate-900 dark:border-slate-700 dark:text-white"
                />
              </div>

              <div>
                <label className="label-text text-xs font-semibold text-slate-600 dark:text-slate-200">
                  Secteur
                </label>
                <input
                  type="text"
                  name="secteur"
                  value={formData.secteur}
                  onChange={handleChange}
                  className="input input-bordered w-full mt-1 dark:bg-slate-900 dark:border-slate-700 dark:text-white"
                />
              </div>

              <div>
                <label className="label-text text-xs font-semibold text-slate-600 dark:text-slate-200">
                  Secteur géographique
                </label>
                <input
                  type="text"
                  name="secteur_geo"
                  value={formData.secteur_geo}
                  onChange={handleChange}
                  className="input input-bordered w-full mt-1 dark:bg-slate-900 dark:border-slate-700 dark:text-white"
                />
              </div>

              <div>
                <label className="label-text text-xs font-semibold text-slate-600 dark:text-slate-200">
                  Coordonnées GPS
                </label>
                <input
                  type="text"
                  name="coordonnees_gps"
                  value={formData.coordonnees_gps}
                  onChange={handleChange}
                  placeholder="Ex : 44.84, -0.58"
                  className="input input-bordered w-full mt-1 dark:bg-slate-900 dark:border-slate-700 dark:text-white"
                />
                <p className="mt-1 text-[10px] text-slate-400">
                  Utilisé pour l’affichage sur la carte (lat, lng).
                </p>
              </div>

              <div>
                <label className="label-text text-xs font-semibold text-slate-600 dark:text-slate-200">
                  Lien Google Maps
                </label>
                <input
                  type="text"
                  name="lien_maps"
                  value={formData.lien_maps}
                  onChange={handleChange}
                  className="input input-bordered w-full mt-1 dark:bg-slate-900 dark:border-slate-700 dark:text-white"
                />
              </div>
            </div>
          </section>

          {/* SECTION : Web & visuels */}
          <section className="rounded-xl bg-slate-50/80 dark:bg-slate-800/80 p-4 space-y-3">
            <h4 className="text-xs font-semibold uppercase tracking-[0.18em] text-slate-500 dark:text-slate-300 mb-1">
              Web & visuels
            </h4>
            <div className="grid md:grid-cols-2 gap-3">
              <div>
                <label className="label-text text-xs font-semibold text-slate-600 dark:text-slate-200">
                  Site internet
                </label>
                <input
                  type="text"
                  name="site_internet"
                  value={formData.site_internet}
                  onChange={handleChange}
                  placeholder="https://…"
                  className="input input-bordered w-full mt-1 dark:bg-slate-900 dark:border-slate-700 dark:text-white"
                />
              </div>

              <div>
                <label className="label-text text-xs font-semibold text-slate-600 dark:text-slate-200">
                  Réseaux sociaux
                </label>
                <input
                  type="text"
                  name="reseaux_sociaux"
                  value={formData.reseaux_sociaux}
                  onChange={handleChange}
                  placeholder="Lien vers la page Facebook, Instagram…"
                  className="input input-bordered w-full mt-1 dark:bg-slate-900 dark:border-slate-700 dark:text-white"
                />
              </div>

              <div className="md:col-span-2">
                <label className="label-text text-xs font-semibold text-slate-600 dark:text-slate-200">
                  Lien du logo
                </label>
                <input
                  type="text"
                  name="lien_logo"
                  value={formData.lien_logo}
                  onChange={handleChange}
                  placeholder="URL de l’image du logo"
                  className="input input-bordered w-full mt-1 dark:bg-slate-900 dark:border-slate-700 dark:text-white"
                />
              </div>
            </div>
          </section>

          {/* ACTIONS */}
          <div className="mt-2 flex justify-center gap-3">
            <Button
              text="Enregistrer"
              icon={FaSave}
              type="submit"
              className="btn-primary gap-2 px-5"
            />
            <Button
              text="Annuler"
              icon={FaTimes}
              onClick={onClose}
              type="button"
              className="btn-ghost gap-2 px-5"
            />
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreateClubModal;
